/* eslint-disable import/no-anonymous-default-export */
const rootIconPath = "/assets/icons";
const rootIllustrationsPath = "/assets/illustrations";

export default {
  illustrations: {
    lock: `${rootIllustrationsPath}/lock.svg`,
  },
  icons: {
    arrow: `${rootIconPath}/arrow.svg`,
    card: `${rootIconPath}/card.svg`,
    copy: `${rootIconPath}/copy.svg`,
    cross: `${rootIconPath}/cross.svg`,
    eyeClose: `${rootIconPath}/eye-close.svg`,
    eyeOpen: `${rootIconPath}/eye-open.svg`,
    folder: `${rootIconPath}/folder.svg`,
    lock: `${rootIconPath}/lock.svg`,
    logout: `${rootIconPath}/logout.svg`,
    moon: `${rootIconPath}/moon.svg`,
    note: `${rootIconPath}/note.svg`,
    search: `${rootIconPath}/search.svg`,
    sun: `${rootIconPath}/sun.svg`,
    user: `${rootIconPath}/user.svg`,
  },
};
